<template>
  <div style="margin-top: 50px">
    <b-row>
      <b-col>
        {{ $t("label_evaluationReport_signature_acknowledgment") }}
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="cardContainer evaluationHeader" style="padding: 0px">
          <div style="text-align: center">
            {{ $t("label_evaluationReport_signature") }}
          </div>
          <div style="height: 100px" />
          <div
            style="
              text-align: center;
              border-top: 1px solid black;
              padding: 5px;
            "
          >
            {{ $t("label_evaluationReport_signature_representative") }}
          </div>
        </div>
      </b-col>
      <b-col>
        <div class="cardContainer evaluationHeader" style="padding: 0px">
          <div style="text-align: center">
            {{ $t("label_evaluationReport_signature") }}
          </div>
          <div style="height: 100px" />
          <div
            style="
              text-align: center;
              border-top: 1px solid black;
              padding: 5px;
            "
          >
            {{ $t("label_evaluationReport_signature_leadAuditor") }}
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="cardContainer evaluationHeader" style="padding: 0px">
          <div style="text-align: center">
            {{ $t("label_evaluationReport_signature") }}
          </div>
          <div style="height: 100px" />
          <div
            style="
              text-align: center;
              border-top: 1px solid black;
              padding: 5px;
            "
          >
            {{ $t("label_evaluationReport_signature_topManagement") }}
          </div>
        </div>
      </b-col>
      <b-col>
        <div class="cardContainer evaluationHeader" style="padding: 0px">
          <div style="text-align: center" />
          <div style="height: 124px" />
          <div
            style="
              text-align: center;
              border-top: 1px solid black;
              padding: 5px;
            "
          >
            {{ $t("label_evaluationReport_signature_organizationStamp") }}
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script >
import { Tree } from "../../../../utils/vue-tree-list";
import { mapGetters } from "vuex";
import { axiosCall } from "../../../../utils/axiosCall";

export default {
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    ...mapGetters(["getBusiness"]),
  },
  name: "EvaluationReportPdfFooter",
  data: function () {
    return {
      today: "",
      data: new Tree([]),
      evaluationId: this.$route.params.evaluationId,
      evaluationData: { evaluation: {} },
      status: "success",
      dataReady: false,
      bussinessLoaded: false,
    };
  },
  async created() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; // January is 0!

    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    this.today = yyyy + "-" + mm + "-" + dd;

    if (this.$route.params.lang) {
      this.$store.dispatch("setLangNew", this.$route.params.lang);
    }
    var auth = {
      data: {
        id: this.$route.params.token,
      },
    };
    var business = {
      id: this.$route.params.businessId,
    };
    this.$store.commit("authSuccess", auth);
    this.$store.commit("setBusiness", business);
    this.$store.commit("setCurrentBusiness", business);
    this.$store
      .dispatch("BUSINESS_GET")
      .then(() => {})
      .catch((err) => {
        console.log(err);
        this.bussinessLoaded = true;
      });
    await axiosCall({ url: "UserAccounts/get", method: "GET" }).then(
      (account) => {
        this.account = account.data;
      }
    );
    await axiosCall({
      url: "Evaluations/" + this.evaluationId,
      method: "GET",
    }).then((response) => {
      this.evaluationData = response.data;
      this.dataReady = true;
    });
  },
};
</script >
<style lang="sass" scoped>
@import "../../../../assets/css/variables"
h4
  font-size: 1.3rem
  text-transform: uppercase

.cardContainer
  border: 1px solid #000000
  width: 100%
  padding: 30px 40px
  margin-bottom: 15px

.cardContainer  h5
    text-align: center
    width: 100%
h4
  font-size: 33px !important
  font-weight: bold !important
  font-family: "Oswald-Light", sans-serif !important
.boldH4
  font-family: "Oswald-Bold", sans-serif !important
  font-size: 41px!important
h2
  color: black
  margin: 1em 0

.label
  font-weight: bold
  font-size: 14px

.h7
  font-weight: bold
  margin-top: 15px

.headerEvaluationReportIcon
  height:  230px
  display: flex
  justify-content: center
  align-items: center

.headerEvaluationReportGreen
  left: 0px
  width: 900px
  height: 1043px
  background: #079690 0% 0% no-repeat padding-box
  border: 1px solid #707070
  opacity: 1
  position: relative

.evaluationReportContent
  margin-left: 1cm
  margin-right: 1cm


.info-company-evaluation
  margin-top: 279px
  color: #FFFFFF
  margin-left: 197px
  width: 420px

.unpd_logo_evaluation
  margin-left: 147px !important
  margin-top: 180px
  position: absolute
  bottom: 50px
</style >
